const getters = {
  device: state => state.app.device,
  token: state => state.user.token,
  id: (state) => state.user.id,
  pici: (state) => state.user.pici,
  realname: (state) => state.user.realname,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js